module.exports = __webpack_public_path__ + "img/group-150x150.78e65984.png";